import { maLookback } from '../../math/ma'
import { COLOR, float, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ENVELOPE',
  version: 1,
  label: 'Envelope',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 44,
  inputs: [period('timeperiod', 20), matype(), float('percent', 10, 'Percent', 0, 100, 0.1)],
  outputs: [line('upper', 'Upper', COLOR.green), line('basis', 'Basis', COLOR.orange), line('lower', 'Lower', COLOR.green)],
  // The bands are the MA scaled by a plain factor (numpy `*`); MULT is listed for the picker's search only.
  talib: {
    functions: ['MA'],
    expr: {
      upper: 'MA(close, timeperiod={timeperiod}, matype={matype}) * (1 + {percent} / 100)',
      basis: 'MA(close, timeperiod={timeperiod}, matype={matype})',
      lower: 'MA(close, timeperiod={timeperiod}, matype={matype}) * (1 - {percent} / 100)',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype }) => maLookback(timeperiod, matype),
}
export default def
